import { get } from 'lodash'

import * as constants from './constants'

const root = state => get(state, 'geolocation')

export const isFetchGeolocationPending = (state) => {
  return get(root(state), 'status') === constants.FETCH_GEOLOCATION_PENDING
}

export const isFetchGeolocationFailure = (state) => {
  return get(root(state), 'status') === constants.FETCH_GEOLOCATION_FAILURE
}

export const isGeolocationLoaded = (state) => {
  const status = get(root(state), 'status')
  return (status === constants.FETCH_GEOLOCATION_SUCCESS) || (status === constants.FETCH_GEOLOCATION_FAILURE)
}

export const getIsGdprApplicable = state => get(root(state), 'data.gdprApplicable')



// WEBPACK FOOTER //
// ./src/modules/geolocation/selectors.js